export default __webpack_public_path__ + "static/media/HydroConnectorsImg.5610cf58.jpg";